import { render, staticRenderFns } from "./OriginatorRestrictionsFilter.vue?vue&type=template&id=810261d0&"
import script from "./OriginatorRestrictionsFilter.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRestrictionsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports